import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { I18n } from "aws-amplify/utils";

const AddNodeModal = ({ open, onClose, onSubmit, parentNode, data }) => {
  const handleCreate = (nodeData) => {
    const completeNode = {
      ...nodeData,
      parentId: parentNode?.id ?? null,
    };
    //console.log("nodo per submit ", completeNode);
    onSubmit(completeNode);
    onClose();
  };
  const [formData, setFormData] = useState({
    // email: "",
    name: "",
    surname: "",
    job_family: "",
    job_function: "",
    role: "",
    department: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const [errors, setErrors] = useState({});
  const handleSubmit = () => {
    const {
      name,
      surname,
      // email,
      job_family,
      job_function,
      role,
      department,
      location,
      legal_entity,
    } = formData;
    const requiredFields = [
      // "name",
      // "surname",
      // "email",
      "role",
      // "job_function",
      // "job_family",
      // "department",
    ];
    const newErrors = {};
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        newErrors[field] = "Required";
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    function generateFakeId(data = [], avoidIds = []) {
      if (!Array.isArray(data)) return "1";
      const existingIds = data.map((item) => parseInt(item.id) || 0);
      const avoidNumericIds = avoidIds.map((id) => parseInt(id) || 0);
      const allIds = [...existingIds, ...avoidNumericIds];
      const maxId = Math.max(0, ...allIds);
      let newId = maxId + 1;

      while (data.some((item) => item.id === newId.toString())) {
        newId++;
      }
      return newId.toString();
    }
    const id = generateFakeId(data, [parentNode.id]);
    console.log(id);
    const newNode = {
      id: id,
      name: `${surname}, ${name}`,
      job_family,
      job_function,
      role,
      location,
      legal_entity,
      department,
      parentId: parentNode?.id ?? null,
      isModified: true,
      isCreated: true,
    };
    handleCreate(newNode);
    onClose();
    setFormData({
      // email: "",
      name: "",
      surname: "",
      job_family: "",
      job_function: "",
      role: "",
      department: "",
      location: "",
    });
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "1rem",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "24px" }} align="center">
          {" "}
          {I18n.get("Create new position")}
        </DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 3,
          }}
        >
          <Box sx={{ display: "flex", gap: 5 }}>
            <TextField
              variant="standard"
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              // required
              error={Boolean(errors.name)}
              helperText={errors.name}
            />
            <TextField
              variant="standard"
              label="Surname"
              name="surname"
              value={formData.surname}
              onChange={handleChange}
              // required
              error={Boolean(errors.surname)}
              helperText={errors.surname}
            />
          </Box>
          {/* <TextField
            variant="standard"
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            // required
            error={Boolean(errors.email)}
            helperText={errors.email}
          /> */}
          <Box sx={{ display: "flex", gap: 5 }}>
            <TextField
              variant="standard"
              label="Role"
              name="role"
              value={formData.role}
              onChange={handleChange}
              required
              error={Boolean(errors.role)}
              helperText={errors.role}
            />
            <TextField
              variant="standard"
              label="Job function"
              name="job_function"
              value={formData.job_function}
              onChange={handleChange}
              // required
              error={Boolean(errors.job_function)}
              helperText={errors.job_function}
            />{" "}
          </Box>
          <Box sx={{ display: "flex", gap: 5 }}>
            <TextField
              variant="standard"
              label="Job family"
              name="job_family"
              value={formData.job_family}
              onChange={handleChange}
              // required
              error={Boolean(errors.job_family)}
              helperText={errors.job_family}
            />
            <TextField
              variant="standard"
              label="Department"
              name="department"
              value={formData.department}
              onChange={handleChange}
              // required
              error={Boolean(errors.department)}
              helperText={errors.department}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            {I18n.get("Cancel")}
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{
              backgroundColor: "#344767",
              color: "rgb(255, 255, 255)",
              "&:hover": {
                backgroundColor: "rgb(40, 55, 80)",
              },
              "&:focus:not(:hover)": {
                backgroundColor: "#344767",
                boxShadow: "none",
              },
            }}
          >
            {I18n.get("Create")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default AddNodeModal;
